import { render } from "./OrderArhive.vue?vue&type=template&id=0322865d"
import script from "./OrderArhive.vue?vue&type=script&lang=js"
export * from "./OrderArhive.vue?vue&type=script&lang=js"

import "./OrderArhive.vue?vue&type=style&index=0&id=0322865d&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__